import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { motion } from 'framer-motion';

import { menuListSelector } from '../../redux/selectors/common-selectors';

import styles from './SideMenu.module.scss';
import SideMenuButton from '../side-menu-button/SideMenuButton';
import {
  containerAnimationConfig,
  fadeInUp,
} from '../../utils/animations-configs';
import {
  SOCIAL_BUTTONS,
  getCompleteMenuButtonsByMenuList,
} from '../../utils/menu-utils';

const SideMenu = ({ isOpened, onMenuButtonClick }) => {
  const history = useHistory();
  const menuList = useSelector(menuListSelector);

  const buttons = getCompleteMenuButtonsByMenuList(menuList);

  const handleOnClick = (path) => {
    onMenuButtonClick();
    history.replace(path);
  };

  if (!isOpened) return null;
  return (
    <div className={styles.container}>
      <motion.ul
        className={styles.buttonsWrapper}
        initial="hidden"
        animate="visible"
        variants={containerAnimationConfig(0.05)}
      >
        {buttons.map((button, index) => (
          <SideMenuButton
            key={index.toString()}
            title={button.title}
            path={button.path}
            onClick={handleOnClick}
          />
        ))}
      </motion.ul>
      <div className={styles.bottomIconsWrapper}>
        <motion.span
          className={styles.bottomText}
          initial="hidden"
          animate="visible"
          variants={fadeInUp}
        >
          FOLLOW US
        </motion.span>
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerAnimationConfig()}
          className={styles.socialIconsWrapper}
        >
          {SOCIAL_BUTTONS.map((button, index) => (
            <a
              key={`${button.alt}-${index.toString()}`}
              href={button.url}
              target="_new"
            >
              <motion.img
                variants={fadeInUp}
                className={styles.socialIcon}
                src={button.icon}
                alt={button.alt}
              />
            </a>
          ))}
        </motion.div>
      </div>
    </div>
  );
};

SideMenu.propTypes = {
  isOpened: PropTypes.bool.isRequired,
  onMenuButtonClick: PropTypes.func.isRequired,
};

export default SideMenu;
